import { defineAsyncActionTypes } from 'store/common/action-helpers';

const prefix = 'graphql/UpdateBasicInfo';
// FOR ONE GRAPHQL QUERY
export const UPDATE_BASIC_INFO = defineAsyncActionTypes(`${prefix}/UPDATE_BASIC_INFO`);



// WEBPACK FOOTER //
// ./src/store/graphql/UpdateBasicInfo/action-types.js